import { List, Record } from 'immutable';

export const ProvincesList = new Record({
	id: null,
	isNew: true,
	count: null,
	items: new List(),
	created_at: new Date(),
})

export function createProvincesList(data) {

	if (data.items)
		data.items.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1)

	let items = data.items.reduce((list, province) => {
			list.push({
				id:Number(province.id),
				nombre:province.nombre
			});
			return list;
		}, []);

	return new ProvincesList({
		id: data.id,
		isNew: false,
		items : new List(items) || new List(),
		count: data.count,
	});
}
